import React from "react";
import moment from "moment";
// import axios from "axios";

import EditModal from "./Modal/EditModal";
import DetailModal from "./Modal/DetailModal";
import MoreOption from "./MoreOption";

import { ItemTypes } from "./ItemTypes";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import IconButton from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useDrag } from "react-dnd";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  }
}));

export default function TodoList(props) {
  const classes = useStyles();
  const [openEditModal, setEditModal] = React.useState(false);
  const [openDetailModal, setDetailModal] = React.useState(false);

  const {
    data,
    deleteDataHandler,
    changeStatusStateHandler,
    updateDataHandler
  } = props;
  // console.log(data);

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.LIST, data },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  const deadlineClasses = () => {
    const now = parseInt(moment(new Date()).format("DD"));
    const deadline = parseInt(moment(data.deadline).format("DD"));
    // console.log(deadline - now);

    if (deadline - now <= 3) {
      return "error";
    } else {
      return "primary";
    }
    // console.log(now + deadline);
  };

  const assignmentIcon = status => {
    switch (status) {
      case "doing":
        return <AssignmentIcon fontSize="large" color={deadlineClasses()} />;
      case "completed":
        return <AssignmentTurnedInIcon fontSize="large" color="primary" />;
      default:
        return (
          <AssignmentLateIcon fontSize="large" color={deadlineClasses()} />
        );
    }
  };

  const deleteList = event => {
    // const url = `http://localhost:5000/delete/${data._id}`;
    deleteDataHandler(data);

    // axios
    //   .delete(url)
    //   .then(response => {
    //     deleteDataHandler(data);
    //   })
    //   .catch(err => console.log(err));
    // deleteDataHandler(data);
    // console.log(data);
  };

  const nextStatusHelper = status => {
    switch (status) {
      case "todo":
        return "doing";
      case "doing":
        return "completed";
      default:
        return "todo";
    }
  };

  const backStatusHelper = status => {
    switch (status) {
      case "completed":
        return "doing";
      case "doing":
        return "todo";
      default:
        return "completed";
    }
  };

  const changeStatusHandler = action => {
    // const url = `http://localhost:5000/changestatus`;
    let status;

    console.log(action);
    if (action === "next") {
      status = nextStatusHelper(data.status);
    } else if (action === "back") {
      // console.log(status);
      status = backStatusHelper(data.status);
      // console.log(status);
    } else {
      console.log(`action is ${action}`);
    }
    const body = {
      id: data._id,
      status
    };
    changeStatusStateHandler({ body, response: "success" });

    // axios
    //   .put(url, body)
    //   .then(response => {
    //     // console.log({ body, response: response.data });
    //     changeStatusStateHandler({ body, response: response.data });
    //   })
    //   .catch(err => console.log(err));
  };

  // Before get changed before some UI bug when you click different part, it will have different event property
  // const changeStatusHandler = (action, event) => {
  //   // const action = event.target.getAttribute("name");
  //   const url = `http://localhost:5000/changestatus`;
  //   let status;

  //   // console.log(event.target);
  //   if (action === "next") {
  //     status = nextStatusHelper(data.status);
  //   } else if (action === "back") {
  //     // console.log(status);
  //     status = backStatusHelper(data.status);
  //     // console.log(status);
  //   } else {
  //     console.log(`action is ${action}`);
  //   }
  //   const body = {
  //     id: data._id,
  //     status
  //   };
  //   axios
  //     .put(url, body)
  //     .then(response => {
  //       // console.log({ body, response: response.data });
  //       changeStatusStateHandler({ body, response: response.data });
  //     })
  //     .catch(err => console.log(err));
  // };

  const renderButtonByStatus = () => {
    switch (data.status) {
      case "todo":
        return (
          <React.Fragment>
            {/* <IconButton
              onClick={deleteList}
              className={classes.button}
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton> */}
            <IconButton
              className={classes.button}
              aria-label="next"
              onClick={() => changeStatusHandler("next")}
              name="next"
            >
              <ArrowForwardIcon name="next" />
            </IconButton>
          </React.Fragment>
        );
      case "doing":
        return (
          <React.Fragment>
            <IconButton
              onClick={() => changeStatusHandler("back")}
              className={classes.button}
              aria-label="back"
              name="back"
            >
              <ArrowBackIcon name="back" />
            </IconButton>
            {/* <IconButton
              onClick={deleteList}
              className={classes.button}
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton> */}
            <IconButton
              className={classes.button}
              aria-label="next"
              onClick={() => changeStatusHandler("next")}
              name="next"
            >
              <ArrowForwardIcon name="next" />
            </IconButton>
          </React.Fragment>
        );
      case "completed":
        return (
          <React.Fragment>
            <IconButton
              onClick={() => changeStatusHandler("back")}
              className={classes.button}
              aria-label="back"
              name="back"
            >
              <ArrowBackIcon name="back" />
            </IconButton>
            {/* <IconButton
              onClick={deleteList}
              className={classes.button}
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton> */}
          </React.Fragment>
        );
      default:
        return (
          <IconButton onClick={deleteList} className={classes.button}>
            <h4>Something went wrong</h4>
            <DeleteIcon aria-label="delete" />
          </IconButton>
        );
    }
  };

  return (
    <React.Fragment>
      <EditModal
        openEditModal={openEditModal}
        setEditModal={setEditModal}
        data={data}
        updateDataHandler={updateDataHandler}
      />
      <DetailModal
        openDetailModal={openDetailModal}
        setDetailModal={setDetailModal}
        data={data}
      />
      <div
        ref={drag}
        style={{
          opacity: isDragging ? 0 : 1,
          fontSize: 25,
          fontWeight: "bold",
          cursor: "grab"
        }}
      >
        <ListItem color="primary" divider dense={true}>
          {assignmentIcon(data.status)}
          <ListItemText
            primary={data.title}
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textSecondary"
                >
                  {data.body}
                </Typography>
                <br></br>
                {`Deadline: ${moment(data.deadline).format("MMMM Do, YYYY")}`}
              </React.Fragment>
            }
            // secondary={`Deadline: ${moment(data.deadline).format(
            //   "MMMM Do, YYYY"
            // )}`}
          />
          {renderButtonByStatus()}
          <MoreOption
            deleteList={deleteList}
            setEditModal={setEditModal}
            setDetailModal={setDetailModal}
          />
        </ListItem>
      </div>
    </React.Fragment>
  );
}
